import history from 'services/history';
import { getInvoicesService, updateInvoiceService } from 'services/invoice';

export const setLoading = (dispatch, value) => {
  dispatch({
    type: 'SET_LOADING',
    payload: value,
  });
};

const mapPriorityStatus = (priority: number) => {
  switch (priority) {
    case 0:
      return undefined;
    case 1:
      return false;
    case 2:
      return true;
    default:
      true;
  }
};

export const getInvoices = async (
  dispatch,
  page,
  search,
  status,
  order,
  ctrl,
) => {
  setLoading(dispatch, true);
  try {
    const { data } = await getInvoicesService(
      {
        ...search,
        page,
        status,
        [`${order?.column}_order`]: mapPriorityStatus(order?.value),
      },
      ctrl,
    );

    dispatch({
      type: 'GET_INVOICES',
      payload: data,
    });
    setLoading(dispatch, false);
  } catch (e) {
    if (e.message !== 'canceled') setLoading(dispatch, false);
    if (e?.response?.status === 404) {
      history.push('/404');
    }
  }
};

export const updateInvoice = async (dispatch, field, value, id) => {
  try {
    const { data } = await updateInvoiceService(id, {
      [field]: value,
    });

    dispatch({
      type: 'UPDATE_INVOICE',
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: 'UPDATE_INVOICE_ERROR',
      payload: e?.response?.data,
    });
  }
};
